var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBlueGroupAction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "13px",
    viewBox: "0 0 14 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "group_action") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCBB-ADMIN-(Web)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clients",
    transform: "translate(-973.000000, -123.000000)",
    fill: "#4E80EE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buttons-/-Icon-export",
    transform: "translate(954.000000, 111.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group_action",
    transform: "translate(19.500000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.44444444,11.5532049 L2.46566667,11.5532049 L9.19244444,4.81550345 L8.17122222,3.79261933 L1.44444444,10.5303208 L1.44444444,11.5532049 Z M13,13 L0,13 L0,9.9306532 L9.70302667,0.21180096 C9.83851556,0.0761853347 10.0221333,0 10.2136667,0 C10.4052,0 10.5888178,0.0761853347 10.7243067,0.21180096 L12.7674444,2.25829316 C12.9028178,2.39395046 12.9789111,2.57791334 12.9789111,2.76973522 C12.9789111,2.96155131 12.9028178,3.14551998 12.7674444,3.28117728 L4.50883333,11.5532049 L13,11.5532049 L13,13 Z M9.19244444,2.76973522 L10.2136667,3.79261933 L11.2348889,2.76973522 L10.2136667,1.74685111 L9.19244444,2.76973522 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlueGroupAction);
export default __webpack_public_path__ + "static/media/icon_blue_group_action.0f5e46360f8b37bda9f14d074bee2f30.svg";
export { ForwardRef as ReactComponent };